(function ($) {

    /**
     * Open Modal
     */
    $(document).on('click', '[data-open-modal]', function(e) {
        e.preventDefault();
        var targetModal = $(this).data('open-modal');
        $(targetModal).addClass('active');
        $('body').addClass('fixed');
    });

    /**
     * Close Modal from close button
     */
    $(document).on('click', '[data-close-modal]', function(e) {
        e.preventDefault();
        var targetModal = $(this).data('close-modal');
        $(targetModal).removeClass('active');
        $('body').removeClass('fixed');
    });

    /**
     * Close Modal from ESC key
     */
    $(document).on('keyup',function(e) {
        if (e.keyCode === 27) {
            if ( $('.c-modal').hasClass('active') ) {
                $('.c-modal').removeClass('active');
                $('body').removeClass('fixed');
            }
        }
    });

})(jQuery);
